export var HiringStep;
(function (HiringStep) {
    HiringStep["PRODUCT_FAMILY"] = "product-family";
    HiringStep["ADDRESS"] = "address";
    HiringStep["EMPLOYEES"] = "employees";
    HiringStep["TERMS"] = "terms";
    HiringStep["TERMS_AUXILIO"] = "terms-auxilio";
    HiringStep["TERMS_PAT"] = "terms-pat";
})(HiringStep || (HiringStep = {}));
export var SidebarStep;
(function (SidebarStep) {
    SidebarStep[SidebarStep["PRODUCT_FAMILY"] = 1] = "PRODUCT_FAMILY";
    SidebarStep[SidebarStep["ADDRESS"] = 2] = "ADDRESS";
    SidebarStep[SidebarStep["EMPLOYEES"] = 3] = "EMPLOYEES";
    SidebarStep[SidebarStep["CONTRACT"] = 4] = "CONTRACT";
    SidebarStep[SidebarStep["REQUEST"] = 5] = "REQUEST";
})(SidebarStep || (SidebarStep = {}));
export var SidebarStatus;
(function (SidebarStatus) {
    SidebarStatus["ACTIVE"] = "active";
    SidebarStatus["COMPLETE"] = "completed";
    SidebarStatus["INACTIVE"] = "inactive";
})(SidebarStatus || (SidebarStatus = {}));
